import { useCallback, useEffect, useRef, useState } from 'react';

import { debounce } from 'lodash';

const DELAY = 500;

const useSearchBar = () => {
  // Value displayed in the search bar.
  const [searchInput, setSearchInput] = useState('');

  // Value used by the search query.
  const [searchQuery, setSearchQuery] = useState('');

  const debouncedFn = useRef(
    debounce((value) => {
      setSearchQuery(value);
    }, DELAY)
  ).current;

  // On unmount, cancels any pending debounced operations.
  useEffect(() => {
    return () => {
      debouncedFn.cancel();
    };
  }, [debouncedFn]);

  // Stores the value in the search bar and then processes the query.
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    debouncedFn(value);
  };

  // Cancels any pending searches and clears the search bar / query.
  const resetSearch = useCallback(() => {
    debouncedFn.cancel();
    setSearchInput('');
    setSearchQuery('');
  }, [debouncedFn]);

  return {
    handleSearchChange,
    resetSearch,
    searchInput,
    searchQuery,
  };
};

export default useSearchBar;
